// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { editCardModalStyles } from "@awc/Overrides/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { modalButtonsActionStyles, xScreen } from "@awc/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

editCardModalStyles.cancelGridItem = {
    width: [12, 6, 2, 2, 2],
    css: css`
        ${xScreen("lte", "xs")} {
            order: 1;
        }
    `,
};

editCardModalStyles.saveGridItem = {
    width: [12, 6, 2, 2, 2],
};

editCardModalStyles.container = {
    gap: 12,
};

editCardModalStyles.editCardModal = {
    cssOverrides: {
        modalContent: css`
            overflow-x: hidden;
        `,
    },
};

editCardModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    margin-right: 10px;
                `,
                css`
                    margin-right: 10px;
                `,
                css`
                    margin-right: 10px;
                `,
            ])}
    `,
};

editCardModalStyles.saveButton = {
    ...modalButtonsActionStyles.submitButton,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                    margin-top: 10px;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
};
